import { Injectable } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { IosSheetComponent } from '../components/ios-sheet/ios-sheet.component';
@Injectable({
  providedIn: 'root'
})
export class IosPwaService {

  constructor(private bottomSheet: MatBottomSheet) { }
  checkForiOS() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const isIos = /iphone|ipad|ipod/.test(userAgent);
    const isInStandaloneMode = window.matchMedia('(display-mode: standalone)').matches;

    if (isIos && !isInStandaloneMode) {
      this.bottomSheet.open(IosSheetComponent);
    }


  }
}
